// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IwM4B","footer":"styles_footer__22Y8h","passCodeTooltip":"styles_passCodeTooltip__1qcub"};